var _path, _path2, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcon3DView = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "3D view",
  xmlns: "http://www.w3.org/2000/svg",
  width: 35.993,
  height: 35.379
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon awesome-cube",
  d: "M16.812.215 2.187 5.699A3.38 3.38 0 0 0 0 8.863v15.828a3.373 3.373 0 0 0 1.863 3.016l14.625 7.313a3.351 3.351 0 0 0 3.016 0l14.626-7.313a3.368 3.368 0 0 0 1.863-3.016V8.863a3.37 3.37 0 0 0-2.187-3.157L19.181.222a3.316 3.316 0 0 0-2.369-.007ZM18 4.581l13.5 5.063v.077L18 15.206 4.5 9.721v-.077Zm2.25 25.031V19.143l11.25-4.571v9.415Z",
  fill: "#e1e1e1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon material-crop-rotate",
  d: "M11.789 29.452a14.433 14.433 0 0 1-8.182-11.636H1.551a16.438 16.438 0 0 0 16.377 15.076c.315 0 .6-.027.9-.041l-5.217-5.236ZM18.065 0c-.315 0-.6.027-.9.055l5.222 5.222 1.823-1.823a14.392 14.392 0 0 1 8.182 11.622h2.056A16.438 16.438 0 0 0 18.065 0Z",
  fill: "#1f1f1f"
})), _text || (_text = /*#__PURE__*/React.createElement("text", {
  "data-name": "3D",
  transform: "translate(7.05 21.344)",
  fill: "#1f1f1f",
  fontSize: 16,
  fontFamily: "ArialMT, Arial"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "3D"))));
export default SvgIcon3DView;